import { render, staticRenderFns } from "./PrevCheck.vue?vue&type=template&id=a4b42342&scoped=true&"
import script from "./PrevCheck.vue?vue&type=script&lang=js&"
export * from "./PrevCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b42342",
  null
  
)

export default component.exports